














import { Vue, Component, Prop } from "vue-property-decorator";
import TextInput, { InputType } from "@/basics/inputs/TextInput.vue";
import LabelTitle from "@/basics/inputs/LabelTitle.vue";

@Component({
  components: { TextInput, LabelTitle }
})
export default class LabelInputText extends Vue {
  @Prop({ type: String, required: false, default: "" }) value!: string;
  @Prop({ type: String, required: false, default: "text" }) type!: InputType;
  @Prop({ type: String, required: false, default: "" }) placeholder!: InputType;
}
